/**
 * PitchBook Admin API
 * PitchBook Admin OpenAPI specification
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {createAction} from '@reduxjs/toolkit';
import {ApiMethods, ConcurrentStrategies} from '@pb/middleware-api';
import {PayloadData} from '../types';
import type {BulkProgress} from '../models/BulkProgress';
import type {Error} from '../models/Error';
import type {UpdateEntitiesEntitlementsRelation} from '../models/UpdateEntitiesEntitlementsRelation';
import type {UpdateUserEntitlementsResult} from '../models/UpdateUserEntitlementsResult';

export interface BulkDischargeUsersEntitlements$Request {
    updateEntitiesEntitlementsRelation: UpdateEntitiesEntitlementsRelation;
    reason?: string;
}

export interface BulkDischargeUsersEntitlements$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const bulkDischargeUsersEntitlementsRequest = createAction<PayloadData<void, BulkDischargeUsersEntitlements$Request>>('BULK_DISCHARGE_USERS_ENTITLEMENTS__BULK_DISCHARGE_USERS_ENTITLEMENTS__REQUEST');
export const bulkDischargeUsersEntitlementsSuccess = createAction<PayloadData<string, BulkDischargeUsersEntitlements$Request>>('BULK_DISCHARGE_USERS_ENTITLEMENTS__BULK_DISCHARGE_USERS_ENTITLEMENTS__SUCCESS');
export const bulkDischargeUsersEntitlementsFailure = createAction<PayloadData<Error, BulkDischargeUsersEntitlements$Request, true>>('BULK_DISCHARGE_USERS_ENTITLEMENTS__BULK_DISCHARGE_USERS_ENTITLEMENTS__FAILURE');

export const bulkDischargeUsersEntitlementsActions = [
    bulkDischargeUsersEntitlementsRequest,
    bulkDischargeUsersEntitlementsSuccess,
    bulkDischargeUsersEntitlementsFailure
] as const;

/**
 * @param {UpdateEntitiesEntitlementsRelation} meta.updateEntitiesEntitlementsRelation
 * @param {string} [meta.reason] Optional audit reason for this update. Blank values use the existing operation-specific reason.
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const bulkDischargeUsersEntitlements = (meta: BulkDischargeUsersEntitlements$Request, config?: BulkDischargeUsersEntitlements$Config) => {
    const TRANSPORT_GET_PARAMS = {
        reason: meta.reason,
    };
    return {
        CALL_API: {
            types: bulkDischargeUsersEntitlementsActions,
            method: ApiMethods.PUT,
            endpoint: `/web-api/bulk-actions/users/entitlements/discharge`,
            TRANSPORT_GET_PARAMS,
            TRANSPORT_REQUEST_BODY: meta.updateEntitiesEntitlementsRelation,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

export interface GetDischargeUsersEntitlementsProgress$Request {
    id: string;
}

export interface GetDischargeUsersEntitlementsProgress$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const getDischargeUsersEntitlementsProgressRequest = createAction<PayloadData<void, GetDischargeUsersEntitlementsProgress$Request>>('BULK_DISCHARGE_USERS_ENTITLEMENTS__GET_DISCHARGE_USERS_ENTITLEMENTS_PROGRESS__REQUEST');
export const getDischargeUsersEntitlementsProgressSuccess = createAction<PayloadData<BulkProgress, GetDischargeUsersEntitlementsProgress$Request>>('BULK_DISCHARGE_USERS_ENTITLEMENTS__GET_DISCHARGE_USERS_ENTITLEMENTS_PROGRESS__SUCCESS');
export const getDischargeUsersEntitlementsProgressFailure = createAction<PayloadData<Error, GetDischargeUsersEntitlementsProgress$Request, true>>('BULK_DISCHARGE_USERS_ENTITLEMENTS__GET_DISCHARGE_USERS_ENTITLEMENTS_PROGRESS__FAILURE');

export const getDischargeUsersEntitlementsProgressActions = [
    getDischargeUsersEntitlementsProgressRequest,
    getDischargeUsersEntitlementsProgressSuccess,
    getDischargeUsersEntitlementsProgressFailure
] as const;

/**
 * @param {string} meta.id Bulk operation id
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const getDischargeUsersEntitlementsProgress = (meta: GetDischargeUsersEntitlementsProgress$Request, config?: GetDischargeUsersEntitlementsProgress$Config) => {
    const TRANSPORT_GET_PARAMS = {
        id: meta.id,
    };
    return {
        CALL_API: {
            types: getDischargeUsersEntitlementsProgressActions,
            method: ApiMethods.GET,
            endpoint: `/web-api/bulk-actions/users/entitlements/discharge/progress`,
            TRANSPORT_GET_PARAMS,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

export interface GetDischargeUsersEntitlementsResult$Request {
    id: string;
}

export interface GetDischargeUsersEntitlementsResult$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const getDischargeUsersEntitlementsResultRequest = createAction<PayloadData<void, GetDischargeUsersEntitlementsResult$Request>>('BULK_DISCHARGE_USERS_ENTITLEMENTS__GET_DISCHARGE_USERS_ENTITLEMENTS_RESULT__REQUEST');
export const getDischargeUsersEntitlementsResultSuccess = createAction<PayloadData<UpdateUserEntitlementsResult, GetDischargeUsersEntitlementsResult$Request>>('BULK_DISCHARGE_USERS_ENTITLEMENTS__GET_DISCHARGE_USERS_ENTITLEMENTS_RESULT__SUCCESS');
export const getDischargeUsersEntitlementsResultFailure = createAction<PayloadData<Error, GetDischargeUsersEntitlementsResult$Request, true>>('BULK_DISCHARGE_USERS_ENTITLEMENTS__GET_DISCHARGE_USERS_ENTITLEMENTS_RESULT__FAILURE');

export const getDischargeUsersEntitlementsResultActions = [
    getDischargeUsersEntitlementsResultRequest,
    getDischargeUsersEntitlementsResultSuccess,
    getDischargeUsersEntitlementsResultFailure
] as const;

/**
 * @param {string} meta.id Bulk operation id
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const getDischargeUsersEntitlementsResult = (meta: GetDischargeUsersEntitlementsResult$Request, config?: GetDischargeUsersEntitlementsResult$Config) => {
    const TRANSPORT_GET_PARAMS = {
        id: meta.id,
    };
    return {
        CALL_API: {
            types: getDischargeUsersEntitlementsResultActions,
            method: ApiMethods.GET,
            endpoint: `/web-api/bulk-actions/users/entitlements/discharge`,
            TRANSPORT_GET_PARAMS,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

export interface StopBulkActions$Request {
    id: string;
}

export interface StopBulkActions$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const stopBulkActionsRequest = createAction<PayloadData<void, StopBulkActions$Request>>('BULK_DISCHARGE_USERS_ENTITLEMENTS__STOP_BULK_ACTIONS__REQUEST');
export const stopBulkActionsSuccess = createAction<PayloadData<void, StopBulkActions$Request>>('BULK_DISCHARGE_USERS_ENTITLEMENTS__STOP_BULK_ACTIONS__SUCCESS');
export const stopBulkActionsFailure = createAction<PayloadData<Error, StopBulkActions$Request, true>>('BULK_DISCHARGE_USERS_ENTITLEMENTS__STOP_BULK_ACTIONS__FAILURE');

export const stopBulkActionsActions = [
    stopBulkActionsRequest,
    stopBulkActionsSuccess,
    stopBulkActionsFailure
] as const;

/**
 * @param {string} meta.id Bulk operation id
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const stopBulkActions = (meta: StopBulkActions$Request, config?: StopBulkActions$Config) => {
    const TRANSPORT_GET_PARAMS = {
        id: meta.id,
    };
    return {
        CALL_API: {
            types: stopBulkActionsActions,
            method: ApiMethods.DELETE,
            endpoint: `/web-api/bulk-actions/users/entitlements/discharge`,
            TRANSPORT_GET_PARAMS,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

